export default "__VITE_ASSET__CMk7nCrt__"